export default __webpack_public_path__ + "static/media/home.7c511a46.svg";